import { combineReducers } from '@reduxjs/toolkit';
import ListReducers from './list';
import FormReducers from './form';
import AccountsToExportReducers from './accountsToExport';
import SelectedAccountReducers from './account';
import UpdateBillingContactReducers from './updateAccountBillingContact/updateAccountBillingContact';
import HubspotAccountsReducers from './hubspotAccounts';
import HubspotDealsReducers from './hubspotDeals';
import { projectsReducer } from './projects/projects';
import UpdateAccountActiveStatusBulkReducers from './updateAccountActiveStatusBulk/updateAccountActiveStatusBulk';
import GetAccountExtraDataReducers from '../auth/fetchAccountExtraData.slices';
import UpdatePaymentMethodReducers from './updatePaymentMethod/updatePaymentMethod.slices';
import previewEnterpriseLicenseCostReducers from './previewEnterpriseLicenseCost';
import addEnterpriseSeatsReducers from './addEnterpriseSeats';
import previewProratedEnterpriseLicenseCostReducers from './previewProratedEnterpriseLicenseCost';
import invoiceDealValidationReducers from '../invoices/invoiceDealValidation/invoiceDealValidaton.slices';
import sendLicenseInvoiceReducers from './sendLicenseInvoice';
import upgradeAccountToEnterpriseReducers from './upgrade';
import { videoReducer } from './video';

const accountsReducers = combineReducers({
  list: ListReducers,
  form: FormReducers,
  accountsToExport: AccountsToExportReducers,
  selectedAccount: SelectedAccountReducers,
  updateBillingContact: UpdateBillingContactReducers,
  hubspotAccounts: HubspotAccountsReducers,
  UpdateAccountActiveStatusBulk: UpdateAccountActiveStatusBulkReducers,
  accountExtraData: GetAccountExtraDataReducers,
  paymentMethod: UpdatePaymentMethodReducers,
  hubspotDeals: HubspotDealsReducers,
  projects: projectsReducer,
  previewEnterpriseLicenseCost: previewEnterpriseLicenseCostReducers,
  addEnterpriseSeats: addEnterpriseSeatsReducers,
  previewProratedEnterpriseLicenseCost: previewProratedEnterpriseLicenseCostReducers,
  invoiceDealValidation: invoiceDealValidationReducers,
  sendLicenseInvoice: sendLicenseInvoiceReducers,
  upgrade: upgradeAccountToEnterpriseReducers,
  video: videoReducer
});

export default accountsReducers;

export type AccountReducers = ReturnType<typeof accountsReducers>
